import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './AsnOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class AsnOrders_get_license_plates_state_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { license_plate_ids: number[] }): Promise<{ reasons?: string[], license_plates?: { fail_action_reasons: { deletion: string[], unreceive: string[], receive: string[] }, id: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.license_plate_ids)) {
      missingRequiredInParams.push('\'license_plate_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/functions/get_license_plates_state_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

